import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { Compbaser } from "../compbaser/compbases";
import { TranslocoService } from "@ngneat/transloco";
import { MatTreeNestedDataSource } from "@angular/material/tree";
import { NestedTreeControl } from "@angular/cdk/tree";
import { of as observableOf } from "rxjs";
import { SelectionModel } from "@angular/cdk/collections";
import { ICategoryTreeNode } from "../category-tree/tree-service/tree-data.model";
import { TreeFunctionService } from "../category-tree/tree-service/tree-function.service";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from "lodash";

@Component({
    selector: 'app-dialog-category-tree',
    templateUrl: './dialog-category-tree.component.html',
    styleUrls: ['./dialog-category-tree.component.scss']
})
export class DialogCategoryTreeComponent extends Compbaser implements OnInit {
    markTreeSelection = '#FF0000';
    selectedTreePath = '';

    categoryData;
    nestedTreeControl: NestedTreeControl<ICategoryTreeNode>;
    nestedDataSource: MatTreeNestedDataSource<ICategoryTreeNode>;
    clickSelection = new SelectionModel<ICategoryTreeNode>(false /* single */);

    constructor(
        private translocoService: TranslocoService,
        private service: TreeFunctionService,
        private cd: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) private data) {
        super();
        this.nestedTreeControl = new NestedTreeControl<ICategoryTreeNode>(this._getChildren);
        this.nestedDataSource = new MatTreeNestedDataSource();

        if (data) {
            this.selectedTreePath = data.treePath || '';

            this.categoryData = this.buildTreeNode(data.categories);
            this.cd.markForCheck();
            this.setDataSource();
        }
    }

    private _getChildren = (node: ICategoryTreeNode) => observableOf(node.Children);
    hasNestedChild = (_: number, nodeData: ICategoryTreeNode) => nodeData.Children.length > 0;

    ngOnInit(): void {
    }

    /** add root node (for now not used) */
    addNode(node: ICategoryTreeNode) {
        node.TreePath = node.Name;
        this.nestedDataSource.data.push(node);
        this.refreshTreeData(node, 'root');
    }

    /** add a child node */
    addChildNode(childrenNodeData) {
        const newNode = childrenNodeData.node;
        const childPath = childrenNodeData.currentNode.TreePath;
        newNode.TreePath = childPath + (childPath ? "/" : "") + newNode.Name;
        childrenNodeData.currentNode.Children.push(newNode);
        this.refreshTreeData(childrenNodeData.node, 'add');
    }

    /** action when a node is selected */
    onNodeSelected(node: ICategoryTreeNode) {
        this.clickSelection.clear();
        this.clickSelection.toggle(node);
        if (this.data.callback) {
            this.selectedTreePath = node.TreePath;
            this.data.callback(node.TreePath);
        }
    }

    /** edit a node (for now, not called) */
    editNode(nodeToBeEdited) {
        const fatherElement: ICategoryTreeNode = this.service.findFatherNode(nodeToBeEdited.currentNode.Id, this.nestedDataSource.data);
        let elementPosition: number;

        nodeToBeEdited.node.Id = nodeToBeEdited.currentNode.Id;
        if (fatherElement[0]) {
            fatherElement[0].Children[fatherElement[1]] = nodeToBeEdited.node;
        } else {
            elementPosition = this.service.findPosition(nodeToBeEdited.currentNode.Id, this.nestedDataSource.data);
            this.nestedDataSource.data[elementPosition] = nodeToBeEdited.node;
        }
        this.refreshTreeData(nodeToBeEdited.node, 'update');
    }

    /** delete a node (for now, not called) */
    deleteNode(nodeToBeDeleted: ICategoryTreeNode) {
        const deletedElement: ICategoryTreeNode = this.service.findFatherNode(nodeToBeDeleted.Id, this.nestedDataSource.data);
        let elementPosition: number;
        const msg = this.translocoService.translate('general.sureRemove', {}, this.translocoService.getActiveLang());
        this.openDialog(`${msg} ` + nodeToBeDeleted.Name + ` `, {showCancel: true}, (v) => {
            if (!v) return;
            if (deletedElement[0]) {
                deletedElement[0].Children.splice(deletedElement[1], 1);
            } else {
                elementPosition = this.service.findPosition(nodeToBeDeleted.Id, this.nestedDataSource.data);
                this.nestedDataSource.data.splice(elementPosition, 1);
            }
            this.refreshTreeData(nodeToBeDeleted, 'delete');

        });
    }

    /** set mat tree date source */
    setDataSource() {
        this.clickSelection.clear();
        this.nestedDataSource.data = this.categoryData;
        this.nestedTreeControl.dataNodes = this.nestedDataSource.data;
        this.nestedTreeControl.expand(this.categoryData[0]);
    }

    /** Refresh tree */
    refreshTreeData(updatedNode: ICategoryTreeNode, action) {
        const data = this.nestedDataSource.data;
        this.nestedDataSource.data = [];
        this.nestedDataSource.data = data;
    }

    /** Convert tree node from category list */
    private buildTreeNode(nodeList) {
        /** sample input data */
        // const arr = [
        //     'abc',
        //     'abc/def',
        //     'zsx',
        //     'abc/qwe/213',
        //     'abc/qwe/azx'
        // ];

        const buildTree = (node: ICategoryTreeNode, str: String) => {
            if (!str) {
                return;
            }

            const arr = str.split("/");
            const firstChunk = arr[0];
            const restStr = str.slice(firstChunk.length + 1, str.length);

            let subNode: ICategoryTreeNode;
            const existingNode = node.Children.filter(item => item.Name == firstChunk); 
            if (!existingNode.length) {
                subNode = {
                    Id: _.uniqueId(),
                    Name: firstChunk,
                    TreePath: node.TreePath + (node.TreePath ? "/" : "") + firstChunk,
                    Children: []
                };
                node.Children.push(subNode);
            } else {
                subNode = existingNode[0];
            }

            buildTree(subNode, restStr);
        }

        const root = {
            Id: _.uniqueId(),
            Name: "root",
            TreePath: "",
            Children: []
        };
        for (let item of nodeList) {
            if (item) buildTree(root, item);
        }
        return [root];
    }
}
